import BookmarkIcon from "@assets/svg/BookmarkIcon";
import BriefcaseIcon from "@assets/svg/BriefcaseIcon";
import dayjs from "@lib/dayjs";

const activities = [
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
  {
    icon: <BriefcaseIcon className="w-6 h-6" />,
    desc: "You applied for UX Designer at SearchCo",
  },
  {
    icon: <BookmarkIcon className="w-6 h-6" />,
    desc: "You saved Front-End Developer at TechCorp",
  },
];

const RecentActivity = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0">
      <span className="font-bold text-primary text-sm">Recent Activity</span>
      {/* List Section */}
      <div className="mt-5 flex flex-col gap-5 min-h-0 overflow-y-scroll no-scrollbar">
        {activities?.map((activity, activityIndex) => {
          return (
            <div key={activityIndex} className="flex items-center gap-3.5">
              <div className="flex items-center justify-center w-11 h-11 rounded-md bg-gray-100">
                {activity?.icon}
              </div>
              <div className="flex flex-col justify-between flex-1 gap-2">
                <span className="text-xs text-light-black">
                  {dayjs().format("hh:mm a")}, {dayjs().format("dddd DD MMM")}
                </span>
                <span className="text-xs font-medium">{activity?.desc}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecentActivity;
